import { useConfigStore } from '@/stores';
import { useMemo, useState } from 'react';

export const useBuildingCategory = () => {
    const language = useConfigStore((state) => state.config?.ui?.language ?? 'ko');
    const [selectedCategoryCode, setSelectedCategoryCode] = useState<string | undefined>(undefined);

    const filteredBuildingCategories = useConfigStore(
        (state) => state.config.server?.buildingMenus?.[language]?.find((menu) => menu.menuType === 'FLOOR')?.selectedCategories
    );

    // Find selected category
    const selectedCategory = useMemo(() => {
        if (!selectedCategoryCode || !filteredBuildingCategories) {
            return null;
        }
        return filteredBuildingCategories.find((category) => category.categoryCode === selectedCategoryCode) ?? null;
    }, [selectedCategoryCode, filteredBuildingCategories]);

    // Group category by client code
    const groupedCategoryByClientCode = useMemo(() => {
        const categoryMap: { [clientCode: string]: string[] } = {};
        filteredBuildingCategories?.forEach((category) => {
            if (category.clientCode) {
                if (!categoryMap[category.clientCode]) {
                    categoryMap[category.clientCode] = [];
                }
                const codes = category.mergeCategoryCode ?? [category.categoryCode];
                categoryMap[category.clientCode].push(...codes);
            }
        });

        return categoryMap;
    }, [filteredBuildingCategories]);

    return {
        selectedCategoryCode,
        selectedCategory,
        setSelectedCategoryCode,
        groupedCategoryByClientCode,
    };
};
